export const ERR_BOUNDARY_SUBTITLE =
  "We're currently working to resolve an issue, please try again later.";
export const ERR_BOUNDARY_TITLE = "Oops...something went wrong!";
export const REFRESH = "Refresh My Trips";
